'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectScrollTo = require('../connectors/connectScrollTo.js');

var _connectScrollTo2 = _interopRequireDefault(_connectScrollTo);

var _ScrollTo = require('../components/ScrollTo.js');

var _ScrollTo2 = _interopRequireDefault(_ScrollTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The ScrollTo component will make the page scroll to the component wrapped by it when one of the
 * [search state](guide/Search_state.html) prop is updated. By default when the page number changes,
 * the scroll goes to the wrapped component.
 *
 * @name ScrollTo
 * @kind widget
 * @propType {string} [scrollOn="page"] - Widget state key on which to listen for changes.
 * @themeKey ais-ScrollTo - the root div of the widget
 * @example
 * import React from 'react';
 * import { InstantSearch, ScrollTo, Hits } from 'react-instantsearch/dom';
 *
 * const App = () => (
 *   <InstantSearch
 *     appId="latency"
 *     apiKey="6be0576ff61c053d5f9a3225e2a90f76"
 *     indexName="ikea"
 *   >
 *     <ScrollTo>
 *       <Hits />
 *     </ScrollTo>
 *   </InstantSearch>
 * );
 */
exports.default = (0, _connectScrollTo2.default)(_ScrollTo2.default);


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/widgets/ScrollTo.js
// module id = 1091
// module chunks = 142807904292071